export default {
    SCHEDULE_MONTHLY_RECURRING: 'monthly_recurring',
    SCHEDULE_ANNUAL_ONEOFF: 'annual_oneoff',
    SCHEDULE_ANNUAL_RECURRING: 'annual_recurring',
};



// WEBPACK FOOTER //
// ./app/src/view/upgrade-defines.es6